import type { Metadata } from "next";

import type { AppLocale } from "@/core/i18n/config";
import { createPageMetadata } from "@/shared/lib/seo/site";
import { HOME_PAGE_COPY } from "@/features/home/constants/home-page-copy";

export async function getHomePageMetadata(locale: AppLocale): Promise<Metadata> {
  const metadata = HOME_PAGE_COPY[locale].metadata;

  return createPageMetadata({
    description: metadata.description,
    locale,
    pathname: "/",
    title: metadata.title,
  });
}
